import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import useAxiosPartnerPortal from 'gatsby-theme-kn/src/hooks/useAxiosPartnerPortal'
import { apiURL } from 'gatsby-theme-kn/src/utils/partner_portal_spa'
import LoadingSpinner from 'gatsby-theme-kn/src/components/modules/LoadingSpinner'

const ModalFittingCalculation = ({ postalCodes }) => {
  const { t } = useTranslation()

  const [InputData, setInputData] = useState({
    postal_code: postalCodes[0][1],
    hours: '1',
  })

  const [partnerPortalUrl, setPartnerPortalUrl] = useState(null)
  const [Fdata, setFdata] = useState(false)
  const { data, loading, error } = useAxiosPartnerPortal(
    partnerPortalUrl,
    Fdata,
    'post'
  )

  const FormSubmit = (e) => {
    e.preventDefault()

    const d = new FormData()
    d.append('postal_code', InputData.postal_code)
    d.append('hours', InputData.hours)
    setFdata(d)
    setPartnerPortalUrl(apiURL('fitting_calculation'))

    return true
  }
  return (
    <>
      {loading && <LoadingSpinner />}
      {data && (
        <div dangerouslySetInnerHTML={{ __html: data.message }}></div>
      )}
      {!data && (
        <div className="spa-block-full">
          <form className="needs-validation">
            <div className="form-label-group mb-1">
              <label htmlFor="postal_code">* PLZ-Bereich Montage-Ort</label>
              <select
                className="form-control"
                name="postal_code"
                onChange={(e) =>
                  setInputData({
                    ...InputData,
                    postal_code: e.target.value,
                  })
                }
              >
                {postalCodes.map((postal_code, index) => (
                  <option key={index} value={postal_code[1]}>
                    {postal_code[0]}
                  </option>
                ))}
              </select>
            </div>
            <div className="form-label-group mb-1">
              <label htmlFor="hours">* Montagestunden</label>
              <select
                className="form-control"
                name="hours"
                onChange={(e) =>
                  setInputData({
                    ...InputData,
                    hours: e.target.value,
                  })
                }
              >
                {[1, 2, 3, 4, 5, 6, 7].map((hour, index) => (
                  <option key={index} value={hour}>
                    {hour}
                  </option>
                ))}
              </select>
            </div>

            <button
              className="btn btn-primary btn-sm mt-1"
              type="submit"
              onClick={(e) => FormSubmit(e)}
            >
              Neue Kalkulation
            </button>
          </form>
        </div>
      )}
    </>
  )
}

export default ModalFittingCalculation
